import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { I18n } from '../translate';

export default class ResetCertificate extends Component {
  static propTypes = {
    resetCanvas: PropTypes.func
  };

  render() {
    const { resetCanvas } = this.props;

    return (
      <button
        className="hot-button hot-button--secondary"
        onClick={() => resetCanvas && resetCanvas()}
      >
        <I18n label="config_manager.config_certicate.reset_certificate" />
      </button>
    );
  }
}
